import React from "react";

export default function CompletePayroll() {
  return <div>CompletePayroll</div>;
}
